import { Select, SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { ImpostoDto } from "core/features/Imposto/typings/index";

const { Option } = Select;

export interface SelectAliquotaProps<T = any> extends SelectProps<T> {
  value: any;
  isInvalid?: boolean;
  onChange: (v: any) => void;
  imposto?: ImpostoDto;
}

export enum TipoAliquota {
  AliquotaFornecedor = "1",
  Padrao = "2",
}

function SelectAliquota({
  value,
  isInvalid,
  onChange,
  imposto,
  ...rest
}: SelectAliquotaProps) {
  return (
    <>
      <SelectBaseAntd
        isInvalid={isInvalid}
        size="large"
        getPopupContainer={(node) => node.parentNode}
        placeholder=""
        style={{ width: "100%" }}
        value={value}
        showSearch={false}
        allowClear={false}
        onChange={(ev) => {
          onChange(ev);
        }}
        {...rest}
      >
        <>
          <Option value={TipoAliquota.AliquotaFornecedor} key="a">
            Aliquota deste fornecedor
          </Option>

          <Option value={TipoAliquota.Padrao} key={"p"}>
            Aliquota padrão : {imposto?.aliquota.toFixed(2)}%
          </Option>
        </>
      </SelectBaseAntd>
    </>
  );
}

export default SelectAliquota;
